import { render, staticRenderFns } from "./sureOrder.vue?vue&type=template&id=2d8ccdc6&scoped=true&"
import script from "./sureOrder.vue?vue&type=script&lang=js&"
export * from "./sureOrder.vue?vue&type=script&lang=js&"
import style0 from "./sureOrder.vue?vue&type=style&index=0&id=2d8ccdc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ccdc6",
  null
  
)

export default component.exports